import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'What is mobile car detailing?',
  answer: 'Mobile car detailing is a professional vehicle cleaning service that comes directly to your home or workplace. Detailers bring all the equipment needed to thoroughly clean and restore your car inside and out.'
}, {
  question: 'How much does mobile car detailing cost?',
  answer: 'Mobile detailing typically costs between $100 and $350+ depending on the vehicle size, condition, and services included.'
}, {
  question: 'What is included in a full car detail?',
  answer: 'A full car detail usually includes exterior hand washing, a clay bar treatment to remove deep contamination, wheel cleaning, interior vacuuming, carpet and seat shampooing, leather cleaning and conditioning if applicable, steam sanitizing, interior surface cleaning, window cleaning, and tire dressing.'
}, {
  question: 'How long does a full car detail take?',
  answer: 'Most full car detailing services take between 2–4 hours depending on the size and condition of the vehicle.'
}, {
  question: 'Do mobile detailers bring their own water and power?',
  answer: 'In most cases we bring our own water supply. The only thing typically required is access to an electrical outlet so we can power our equipment. We bring long extension cords if needed.'
}, {
  question: 'Do I need to be present during the detail?',
  answer: 'No. As long as the vehicle is accessible, you do not need to be present during the service.'
}, {
  question: 'Can you detail my car at my home or workplace?',
  answer: 'Yes. Mobile detailing services can be performed at homes, offices, and apartment complexes as long as there is enough space to safely clean the vehicle without blocking traffic or access areas.'
}, {
  question: 'What is included in interior car detailing?',
  answer: 'Interior detailing typically includes vacuuming, wiping interior surfaces, cleaning door panels and dashboards, window cleaning, floor mat cleaning, seat shampooing or leather cleaning and conditioning, and steam sanitizing.'
}, {
  question: 'What is included in exterior car detailing?',
  answer: 'Exterior detailing includes hand washing, wheel and tire cleaning, bug removal, and paint protection treatments such as wax or sealant.'
}, {
  question: 'Can mobile detailing remove stains from seats and carpets?',
  answer: 'Yes. Professional detailing can remove many stains using steam cleaning, shampooing, and extraction methods. However, some stains may return depending on the type of spill and how long it has been present.'
}, {
  question: 'Can detailing remove light scratches from car paint?',
  answer: 'Light surface scratches and water spots can often be improved through paint polishing as part of a detail. Deeper scratches may require additional services.'
}, {
  question: 'How often should I get my car detailed?',
  answer: 'Most vehicles benefit from professional detailing every 2–3 months to maintain appearance and protect the paint and interior.'
}, {
  question: "Does detailing help protect my car's paint?",
  answer: "Yes. Wax, sealants, and ceramic coatings help protect your vehicle's paint from UV rays, dirt, and environmental contamination."
}, {
  question: 'Can you detail trucks and SUVs?',
  answer: 'Yes. Mobile detailing services are available for cars, trucks, SUVs, and vans.'
}, {
  question: 'Do you clean heavily dirty vehicles?',
  answer: 'Yes. However, excessively dirty vehicles may require additional time or deep cleaning services depending on the level of buildup.'
}, {
  question: 'What happens if it rains on the day of my appointment?',
  answer: 'If weather conditions prevent the service, the appointment will be rescheduled for the next available day.'
}, {
  question: 'What payment methods do you accept?',
  answer: 'We accept cash, credit cards, and most digital payment methods.'
}, {
  question: 'Do you service my area?',
  answer: 'Mobile detailing services are provided within our local service area. Contact us to confirm availability in your location.'
}, {
  question: 'How do I book a mobile detailing appointment?',
  answer: 'You can schedule an appointment by calling or texting to choose a time that works best for you.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" id="faq" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <div className="text-center mb-12" data-id="element-130">
          <h2 className="text-5xl md:text-6xl font-black uppercase mb-4" data-id="element-131">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-132">
              Frequently Asked Questions About Mobile Detailing
            </span>
          </h2>
          <div className="h-1 w-24 bg-red-600 mx-auto rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)]" data-id="element-133" />
          <p className="text-gray-400 text-lg max-w-2xl mx-auto mt-4" data-id="element-134">
            Everything you need to know about our professional mobile auto
            detailing service in Los Angeles and Ventura County
          </p>
        </div>

        <div className="space-y-4" data-id="element-135">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          y: 20,
          opacity: 0
        }} whileInView={{
          y: 0,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-zinc-900/40 border border-zinc-800 rounded-xl overflow-hidden" data-id="element-136">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-137">
                <span className="text-white font-bold text-lg pr-8" data-id="element-138">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0" data-id="element-139">
                  <ChevronDown className="w-6 h-6 text-yellow-500" data-id="element-140" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-141">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-142">
                    <div className="px-6 pb-6 text-gray-300 text-base leading-relaxed" data-id="element-143">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}